<div id="header" class="header">
    <div class="logo" routerLink="/home">
        <img src="/assets/images/logo_color.png" alt="logo" class="logo">
    </div>

    <div class="select-container">
        <mat-select class="select-language placeholder-light" [(value)]="selectedLanguage" (selectionChange)="setLanguage()" disableOptionCentering panelClass="languages-panel">
            <mat-select-trigger>
                <img [src]="selectedLanguage === 'en' ? './assets/flagIcons/usa_flag.svg' : './assets/flagIcons/br_flag.svg'" alt="flag">
                    {{ selectedLanguage === 'en' ?  ('header.language.english' | translate ) : ('header.language.portuguese' | translate) }}
            </mat-select-trigger>
            <mat-option value='pt-br'>
                <img [src]="'./assets/flagIcons/br_flag.svg'" alt="flag">
                    {{ 'header.language.portuguese' | translate }}
            </mat-option>
            <mat-option value='en'>
                <img [src]="'./assets/flagIcons/usa_flag.svg'" alt="flag">
                {{ 'header.language.english' | translate }}
            </mat-option>
        </mat-select>
    </div>

    <div class="search">
        <input [(ngModel)]="searchValue" [defaultValue]="searchValue" (input)="searchProduct()" (keydown.enter)="searchProduct(true)" #searchInput [placeholder]="'header.search' | translate" maxlength="50"/>
        <mat-icon (click)="searchProduct(true)" fontSet="material-icons-round" matSuffix class="search-icon">search</mat-icon>
    </div>

    <!-- Button when the user isn't logged in  -->
    <div class="user-data" *ngIf="!loggedUser?.firstName">
        <mat-icon fontSet="material-icons-round" (click)="goOrder()" matTooltipClass="tooltip-secondary"
            [matTooltip]="'header.login' | translate" class="menu-icon">account_circle</mat-icon>
    </div>

    <!-- Button when the user is logged in  -->
    <div class="user-data" *ngIf="loggedUser?.firstName">
        <mat-icon fontSet="material-icons-round"  [matMenuTriggerFor]="menuUser" class="menu-icon">account_circle</mat-icon>
        <mat-menu class="user-menu" #menuUser="matMenu" xPosition="after">
            <div class="currency-info" *ngIf="isTokenEnabled">
                <div class="token-info">
                    <img class="token-icon" src="../../assets/images/token-icon.png" alt="token">
                    <span class="token-name">{{ 'token.name' | translate }}</span>
                </div>
                <p class="small-text">{{ 'header.myBalance' | translate }}</p>
                <div class="bottom" *ngFor="let balance of balances">
                    <strong class="description" *ngIf="!apiOfflineBalance">{{ balance.balance | currency:balance.unitOfMoney:true:'1.6' }}</strong>
                </div>
                <strong class="description" *ngIf="apiOfflineBalance">{{ 'header.unavailable' | translate }}</strong>
            </div>
            <button mat-menu-item class="user-menu-favorite" *ngIf="checkWidth()" (click)="goToFavorites()">
                {{ 'header.favoritesInMenu' | translate }}
            </button>
            <button mat-menu-item (click)="goOrder()">
                {{ 'header.orders' | translate }}
            </button>
            <button mat-menu-item *ngIf="isLetterOfCreditEnabled" [routerLink]="['/credit-conversion/panel']">
                {{ 'header.credit' | translate }}
            </button>
            <button mat-menu-item (click)="changePassword()">
                {{ 'header.changePassword' | translate }}
            </button>
            <button mat-menu-item (click)="logout()">
                {{ 'header.logout' | translate }}
            </button>
        </mat-menu>
        <div class="user-name-container" [matMenuTriggerFor]="menuUser">
            <span class="user-name etc">{{ loggedUser?.firstName }}</span>
            <mat-icon fontSet="material-icons-round" class="down">keyboard_arrow_down</mat-icon>
        </div>
    </div>
    <div class="favorite-container" *ngIf="loggedUser?.firstName">
        <div class="circle red" *ngIf="favorites?.value > 0">
            <span [ngClass]="(favorites?.value < 100) ? 'value': 'value small'">
                {{ (favorites?.value < 100) ? favorites?.value : '+99' }}
            </span>
        </div>
        <mat-icon (click)="goToFavorites()" fontSet="material-icons-round" class="favorite menu-icon" matTooltipClass="tooltip-secondary"
            [matTooltip]="'header.favorites' | translate">favorite</mat-icon>
    </div>
    <div class="shopping-cart-container" *ngIf="loggedUser?.firstName">
        <div class="circle green" *ngIf="carts > 0">
            <span [ngClass]="(carts > 100) ? 'value': 'value small'">
                {{ (carts < 100) ? carts : '+99' }}
            </span>
        </div>
        <mat-icon (click)="goToCart()" fontSet="material-icons-round" class="shopping-cart menu-icon" [matTooltip]="'header.cart' | translate"
            matTooltipClass="tooltip-secondary" >shopping_cart</mat-icon>
    </div>
</div>
<div class="menu-bar">
    <div class="menu-button" [matMenuTriggerFor]="menuBar" >
        <mat-icon fontSet="material-icons-round" class="menu-bar-icon">menu</mat-icon>
        <span class="menu-title">{{ 'header.menuBar.all' | translate }}</span>
    </div>
    <mat-menu class="user-menu" #menuBar="matMenu" xPosition="before">
        <ng-container *ngFor="let item of menuBarItems">
            <button 
                mat-menu-item  
                mat-menu-trigger 
                [matMenuTriggerFor]="menuBarSubCategory" 
                *ngIf="item?.subcategories && item?.subcategories?.length > 0">
                {{ item?.name }}
            </button>
            <button 
                mat-menu-item 
                (click)="searchCategory(item); searchInput.value = '';"
                *ngIf="!item?.subcategories || item?.subcategories?.length === 0">
                {{ item?.name }}
            </button>
            <mat-menu class="user-menu" #menuBarSubCategory="matMenu" yPosition="below">
                <button 
                    mat-menu-item *ngFor="let subcategory of item.subcategories"
                    (click)="searchCategory(subcategory, true); searchInput.value = '';">
                    {{ subcategory?.name }}
                </button>
            </mat-menu>
        </ng-container>
    </mat-menu>

    <div class="items">
        <ng-container *ngFor="let item of lineBarItems">
            <span class="menu-item" *ngIf="item?.subcategories && item?.subcategories?.length > 0" mat-menu-trigger [matMenuTriggerFor]="subCategory">
                {{ item?.name }}
            </span>
            <mat-menu #subCategory="matMenu">
                <button mat-menu-item *ngFor="let subcategory of item.subcategories" (click)="searchCategory(subcategory, true); searchInput.value = '';">
                    {{ subcategory?.name }}
                </button>
            </mat-menu>
            <span class="menu-item" *ngIf="!item?.subcategories || item?.subcategories?.length === 0" (click)="searchCategory(item); searchInput.value = '';">
                {{ item?.name }}
            </span>
        </ng-container>
    </div>
</div>
<mat-progress-spinner *ngIf="loading" class="spinner" [mode]="'indeterminate'"></mat-progress-spinner>
